module.exports = __webpack_public_path__ + "3e36ae101ded3a9c7047ca37a6789b9f.png";